export interface IUserLookup {
    _id: string;
    username: string;
}
